import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('vra_cookie_consent');
    if (!consent) {
      // Show banner after a short delay for better UX
      setTimeout(() => setShowBanner(true), 1000);
    } else if (consent === 'accepted') {
      // Initialize analytics if consent was previously given
      initializeAnalytics();
    }
  }, []);

  const initializeAnalytics = () => {
    // Enable Google Analytics
    if (window.gtag && process.env.REACT_APP_GA_ID) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted'
      });
      console.log('Analytics enabled');
    }
  };

  const handleAccept = () => {
    localStorage.setItem('vra_cookie_consent', 'accepted');
    localStorage.setItem('vra_cookie_consent_date', new Date().toISOString());
    initializeAnalytics();
    setShowBanner(false);
  };

  const handleReject = () => {
    localStorage.setItem('vra_cookie_consent', 'rejected');
    localStorage.setItem('vra_cookie_consent_date', new Date().toISOString());
    // Disable analytics
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'denied'
      });
    }
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[200] p-4 md:p-6 animate-in slide-in-from-bottom duration-500">
      <div className="container mx-auto max-w-6xl">
        <div className="bg-gray-900/95 backdrop-blur-lg border border-red-900/30 rounded-lg shadow-2xl p-6 md:p-8">
          <div className="flex flex-col md:flex-row md:items-center gap-6">
            {/* Content */}
            <div className="flex-1">
              <h3 className="text-xl font-bold text-white mb-3">We use cookies</h3>
              <p className="text-gray-300 text-sm leading-relaxed">
                This website uses cookies to ensure proper functionality and to analyse website traffic using Google Analytics.{' '}
                <Link to="/privacy-policy" className="text-red-400 hover:text-red-300 underline">
                  Learn more in our Privacy Policy
                </Link>
              </p>
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 md:flex-shrink-0">
              <button
                onClick={handleAccept}
                className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white font-semibold rounded-md transition-all transform hover:scale-105 whitespace-nowrap"
              >
                Accept analytics cookies
              </button>
              <button
                onClick={handleReject}
                className="px-6 py-3 bg-gray-700 hover:bg-gray-600 text-white font-semibold rounded-md transition-all whitespace-nowrap"
              >
                Reject non-essential cookies
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
